import {Button, Flex, Text} from '@priority-software/priority-style-react';
import React, {useCallback, useMemo} from 'react';
import {TagsArea} from '../../../../components/Common/TagsArea';
import {observer} from 'mobx-react-lite';
import {analyticsReportsStore} from '../../store/AnalyticsReportsStore';
import texts from '../../../ReportGenerator/texts';

export type Props = {
    componentClasses?: string;
};

export const SearchTags = observer(({componentClasses}: Props) => {
    const {resetFilters, selectedForms, selectedUsers, setSelectedForms, setSelectedUsers} =
        analyticsReportsStore;

    const tags = useMemo(
        () =>
            [...selectedForms, ...selectedUsers].map(tag =>
                tag === '' ? texts.OldGenerator : tag
            ),
        [selectedForms, selectedUsers]
    );
    const onRemove = useCallback(
        (index: number) => {
            if (index <= selectedForms.length - 1) {
                setSelectedForms(
                    selectedForms.filter(form => {
                        if (tags[index] === texts.OldGenerator) {
                            return form !== '';
                        }
                        return form !== tags[index];
                    })
                );
            } else {
                setSelectedUsers(selectedUsers.filter(user => user !== tags[index]));
            }
        },
        [tags]
    );

    return (
        <Flex
            justifyContent="flex-start"
            alignItems="flex-start"
            style={{
                gap: '8px'
            }}
            componentClasses={componentClasses}
        >
            {tags.length ? (
                <>
                    <Text style={{whiteSpace: 'nowrap', marginTop: 3}}>
                        {texts.appliedFilters}:
                    </Text>
                    <TagsArea tags={tags as string[]} removeTag={onRemove} maxHeight={80} />
                    <Button skin="text" onClick={resetFilters}>
                        {texts.clearAll}
                    </Button>
                </>
            ) : (
                ''
            )}
        </Flex>
    );
});
